import { useEffect, useState } from "react";
import api from "./api";

// Per-instance white-label branding (single-tenant productisation).
// Sourced once from the public GET /api/instance/branding endpoint and cached
// at module level so Header/Footer/App share a single fetch. Defaults to the
// Ekselens primary instance so the site is visually unchanged if the call fails.

export const DEFAULT_BRANDING = {
  instance_id: "ekselens-primary",
  name: "Ekselens",
  primary_color: "#7737F6",
  logo_url: "",
  attribution: "Powered by EKSELENS360",
};

let _cache = null;
let _inflight = null;

export async function loadBranding() {
  if (_cache) return _cache;
  if (!_inflight) {
    _inflight = api
      .get("/instance/branding")
      .then(({ data }) => { _cache = { ...DEFAULT_BRANDING, ...(data || {}) }; return _cache; })
      .catch(() => { _cache = DEFAULT_BRANDING; return _cache; });
  }
  return _inflight;
}

// React hook — returns branding (defaults until the fetch resolves).
export function useBranding() {
  const [branding, setBranding] = useState(_cache || DEFAULT_BRANDING);
  useEffect(() => {
    let alive = true;
    loadBranding().then((b) => { if (alive) setBranding(b); });
    return () => { alive = false; };
  }, []);
  return branding;
}
